var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-button',{attrs:{"type":"button","size":"sm","variant":"primary","disabled":_vm.disabled},on:{"click":_vm.addDonation}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Add\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }